import React from 'react';
import TechnologySection from '../components/TechnologySection';
import Footer from '../components/Footer';
import SEOHead from '../components/SEOHead';
import '../styles/HomePage.css';

const TechnologyPage = () => {
  const handleNavigation = (section) => {
    if (section === 'technology') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      document.getElementById(section)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="technology-page pt-20">
      <SEOHead 
        title="Aerogel Technology Platform | SolidCloud International"
        description="Proprietary aerogel platform with 99.8% porosity, 0.013 W/m·K thermal conductivity, and 1200°C temperature resistance. Explore our advanced material formats and capabilities."
        keywords="aerogel technology, thermal conductivity, high temperature resistance, lightweight insulation, aerogel composites, battery thermal barriers"
      />
      <TechnologySection />
      <Footer onNavigate={handleNavigation} />
    </div>
  );
};

export default TechnologyPage;
